import * as React from "react";
import { checkDeviceType } from "src/helpers";
import { makeStyles, Typography, Box } from "@material-ui/core";
import MobileOffIcon from "@material-ui/icons/MobileOff";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme: any) => ({
  mobileIcon: {
    height: "200px",
    width: "200px",
    marginTop: "20px"
  },
  container: {
    marginTop: "50%"
  }
}));
export const DesktopRoute = ({ component: Component, props }: any) => {
  const classes = useStyles();
  const deviceType = checkDeviceType();
  const { t } = useTranslation();

  return deviceType === "mobile" ? (
    <Box display="flex" textAlign="center" flexDirection="column" alignItems="center" className={classes.container}>
      <Typography variant="h1">{t("feedback.dashboard.desktopRouteError")}</Typography>
      <MobileOffIcon className={classes.mobileIcon} />
    </Box>
  ) : (
    <Component {...props} />
  );
};
